//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { bus } from '../bus'
import Multiselect from 'vue-multiselect'

export default {
  name: 'TaxonomySelect',
  props: ['placeholder','terms','taxonomy'],
  components: { Multiselect },
  data () {
    return {
      selected: [],
      options: [],
      queryObj: {},
    }
  },
  watch: {
    terms(terms){
      this.options = terms;
    }
  },
  mounted() {
    bus.$on('resetfilter', () => {
      this.selected = [];
    });
  },
  created() {
    if ( this.$route.query[`t_${this.taxonomy}`] ) {
      this.$route.query[`t_${this.taxonomy}`].split(',').forEach((term_id) => {
        const [selected_term] = this.terms.filter((obj) => {
          return Number(obj.term_taxonomy_id) === Number(term_id);
        });

        this.selected.push(selected_term);
      });
    }

    this.options = this.terms;
  },
  methods: {
    selectChanged(val) {
      let term_ids = [];
      let obj = { ... this.$route.query };

      if ( val.length ) {

        val.forEach((obj) => {
          term_ids.push(obj.term_taxonomy_id);
        });

        obj[`t_${this.taxonomy}`] = term_ids.join(',');

      } else {
        obj[`t_${this.taxonomy}`] = '';
      }

      if ( typeof obj[`t_${this.taxonomy}`] !== "undefined") {
        this.$router.push({
          query: Object.assign({}, this.$route.query, obj),
        });
      }

      this.$emit('tax-changed', val);

    },
  },
}



// WEBPACK FOOTER //
// ./scripts/components/MSelect.vue